module.exports = __webpack_public_path__ + "media/images/about/time/5-4f16a7f23075ee3cc442cc62e81b92e4.png";